$(document).ready(function(){     
  $( ".play-icon" ).on( "click", function() {
    $(".Video-big").trigger('play');
    $(".play-button-wrapper").hide();
  });
  $( ".Video-big" ).on( "click", function() {
    $(".Video-big").trigger('pause');
    $(".play-button-wrapper").show();
  });
  $(document).on('click','.edit-gift-message',function(){
    $(this).parents('.gift-single-properties').addClass('hideMe');
    $(this).parents('.cart-item,.cart-form-item').find('.gift-edit-box').removeClass('hideMe');
  });
  $(document).on('click','.update-gift-message',async function(){
    let productID= $(this).parents('.cart-item,.cart-form-item').attr('data-id');
    let giftMessage  = $(this).parents('.cart-item,.cart-form-item').find('#gift-message-text').val();
    let data = {
          'id': productID,
          'properties':
          {
            "Gift Message": giftMessage
          }
      }
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
    $(this).parents('.cart-item,.cart-form-item').find('.gift-single-properties span').text('Gift Message:' + giftMessage);
    $(this).parents('.cart-item,.cart-form-item').find('.gift-single-properties').removeClass('hideMe');
    $(this).parents('.cart-item,.cart-form-item').find('.gift-edit-box').addClass('hideMe');
  });
});

function myFunction() {
  var checkBox = document.getElementById("myCheck");
  var text = document.getElementById("gift_msg_display");
  if (checkBox.checked == true){
    text.style.display = "block";
  } else {
     text.style.display = "none";
  }
}
